import StyleRoot from "radium/es/components/style-root";
import BranchList from "./BranchList";
import BookWithOffer from "./BookWithOffer";
import BranchDaysList from "./BranchDaysList";
import BranchDayTimesList from "./BranchDayTimesList";
import BookFeesDetails from "./BookFeesDetails";

import {
    setBookWithOfferSkeleton,
    setBranchDaysSkeleton,
    setBranchSkeleton,
    setBranchTimesSkeleton,
    setFeesSkeleton
} from "../../../skeleton";
import Queue from "./Queue";
import {withRouter} from "react-router-dom";
import React from "react";
import {withTranslate} from "react-redux-multilingual";
import BookWithDoctorServices from "./BookWithDoctorServices";

import ReactDOM from 'react-dom';

class SingleDoctorSidebar extends React.Component {

    state = {
        servicesToReserve: null,
        doctor: null,
    };


    componentWillMount() {
        // add event listener for clicks
        document.addEventListener('click', this.handleClick, false);
    }

    componentWillUnmount() {
        // make sure you remove the listener when the component is destroyed
        document.removeEventListener('click', this.handleClick, false);
    }

    handleClick = e => {
        this.props.focusOnSidebar(e);
        // this is the key part - ReactDOM.findDOMNode(this) gives you a reference
        // to your SingleDoctorSidebar component;
        // e.target is the element which was clicked upon.
        // check whether the element clicked upon is in your component - if not,
        // then call the close logic

        // let bookFeesList = document.getElementById("book-fees-list");

    // && !ReactDOM.findDOMNode(this).contains(bookFeesList)
        if (!ReactDOM.findDOMNode(this).contains(e.target) ) {
            // the click was outside your component, so handle closing here
            this.props.closePageOverlay(e)
        }
    }
    setServices = (services) => {
        this.setState({
            servicesToReserve: services,
        }, console.log(services));
    };


    componentWillReceiveProps(nextProps, nextContext) {
        if (!this.state.doctor && this.props.doctor) {
            this.setState({
                doctor: this.props.doctor
            }, () => {
                if (this.state.doctor && this.state.doctor.clinic) {
                    this.props.book(this.state.doctor.clinic);
                }
            });
        }
    }

    render() {
        return (
            <div id="doctor-sidebar" className="flex-item" onClick={(e) => this.handleClick(e)}>
                <div className=" no-padding">
                    <StyleRoot>
                        {
                            !this.props.branchesIsLoading || this.props.currentBranch ?
                                <div className="sidebar-doctor-details shadow-4d">
                                    {
                                        !this.props.successfullyBooked ?
                                            <div className="details-body">
                                                {
                                                    this.props.doctor && this.props.doctor.account_type === 0 ?
                                                        <BranchList branches={this.props.branches}
                                                                    doctor={this.props.doctor}
                                                                    branchesIsLoading={this.props.branchesIsLoading}
                                                                    currentBranch={this.props.currentBranch}
                                                                    book={(currentBranch) => this.props.book(currentBranch)}/>
                                                        :
                                                        null
                                                }

                                                {this.props.currentBranch ?
                                                    <div className="branch"
                                                         key={this.props.currentBranch.id}>

                                                        <div className="branch-header"
                                                             title={this.props.currentBranch.name}>
                                                            <a target="_blank"
                                                               href={"https://maps.googleapis.com/maps/api/place/nearbysearch/json?location=" + this.props.currentBranch.lat + "," + this.props.currentBranch.lng + "&radius=1500&keyword=cruise&key=AIzaSyCMCX9rvYe4HLsuk75TtRyD6_HcWWYPuVM"}><span
                                                                className="icon"><span className="icon">
                                                                    <img src="/images/branch.png"
                                                                         className="money-icon" alt="pin"/>
                                                    </span></span></a>
                                                            <span>{this.props.translate("Book_in_branch")} {this.props.currentBranch.province_name}</span>
                                                            <a href="/"
                                                               onClick={(e) => this.props.cancelBooking(e)}
                                                               className="pull-right cancel-link">{this.props.translate("cancel")}</a>
                                                        </div>


                                                        <div className="branch-body"
                                                             hidden={this.props.currentBookingFeesDetails}>
                                                            {/*************add services****************/}
                                                            {this.props.doctor && this.props.doctor.services && this.props.doctor.services.length
                                                                && !this.props.cachedRescheduleReservation ?
                                                                <div className="add-doctor-services">
                                                                    <BookWithDoctorServices
                                                                        language={this.props.language}
                                                                        setServices={(services) => this.setServices(services)}
                                                                        doctor={this.props.doctor}
                                                                        currentDoctorIsLoading={this.props.currentDoctorIsLoading}/>
                                                                </div> : null}
                                                            {/*************Offer****************/}
                                                            {this.props.offer  && !this.props.cachedRescheduleReservation
                                                                ? (!this.props.offerDetailsIsLoading
                                                                    ? <BookWithOffer doctor={this.props.doctor}
                                                                                     offer={this.props.offer}
                                                                                     removeOfferCache={this.props.removeOfferCache}/>
                                                                    : setBookWithOfferSkeleton())
                                                                : null
                                                            }

                                                            {
                                                                !this.props.currentBranchDaysIsLoading ?
                                                                    this.props.currentBranchDays && this.props.currentBranchDays.length ?
                                                                        <div
                                                                            className="book-reservation-details">
                                                                            <BranchDaysList
                                                                                setCurrentDay={(day, e) => this.props.setCurrentDay(day, e)}
                                                                                currentBranchDays={this.props.currentBranchDays}
                                                                                styles={this.props.styles}
                                                                                currentDay={this.props.currentDay}
                                                                                language={this.props.language}/>

                                                                            {!this.props.currentBranchDayTimesIsLoading ?
                                                                                <BranchDayTimesList
                                                                                    language={this.props.language}
                                                                                    currentBranchDayTimes={this.props.currentBranchDayTimes}
                                                                                    currentBranchDayTimesIsLoading={this.props.currentBranchDayTimesIsLoading}
                                                                                    currentBranch={this.props.currentBranch}
                                                                                    currentTime={this.props.currentTime}
                                                                                    currentTimesPageLimit={this.props.currentTimesPageLimit}
                                                                                    currentTimesPage={this.props.currentTimesPage}
                                                                                    currentBranchDayTimesLimit={this.props.currentBranchDayTimesLimit}
                                                                                    currentTimesPageOffset={this.props.currentTimesPageOffset}
                                                                                    styles={this.props.styles}
                                                                                    setPreviousTimesPage={() => this.props.setPreviousTimesPage()}
                                                                                    setNextTimesPage={() => this.props.setNextTimesPage()}
                                                                                    setCurrentTime={(e, time) => this.props.setCurrentTime(e, time)}
                                                                                />
                                                                                : this.props.currentDay && (this.props.currentBranch.pattern === 0) ? setBranchTimesSkeleton() : null
                                                                            }

                                                                            {/*************queue****************/}

                                                                            <Queue
                                                                                currentBranch={this.props.currentBranch}
                                                                                currentBranchDayBreaks={this.props.currentBranchDayBreaks}
                                                                                currentBranchDayBreaksIsLoading={this.props.currentBranchDayBreaksIsLoading}/>

                                                                            {/************* complaint ****************/}
                                                                            <div className="complaint-wrapper">
                                                                                <p className="mt-20 bolder">{this.props.translate("type")}</p>
                                                                                <select id="type"
                                                                                        className="form-control height-40"

                                                                                        onChange={(e) => this.props.handleFieldOnChange(e)}>
                                                                                    <option
                                                                                        value="0">{this.props.translate("check_up")}
                                                                                    </option>
                                                                                    <option
                                                                                        value="1">{this.props.translate("follow_up")}
                                                                                    </option>
                                                                                </select>
                                                                                {/*    <p className="mt-20">{this.props.translate("write_complaint")}</p>
                                                                        <textarea id="complaint"
                                                                                  placeholder="Complaint ..."
                                                                                  className="form-control"
                                                                                  onChange={(e) => this.props.handleFieldOnChange(e)}></textarea>*/}
                                                                            </div>


                                                                            {/*************btn book****************/}
                                                                            <div className="book-btn-wrapper">
                                                                                <div className="form-group relative">
                                                                                    <button
                                                                                        onClick={this.props.cachedRescheduleReservation ? () => this.props.submitRescheduleReservation() : (e) => this.props.getBookingFees(e, this.state.servicesToReserve, -1)}
                                                                                        type="submit"
                                                                                        className="btn btn-book btn-block shadow-4d height-45 rounded-corners"
                                                                                        disabled={this.props.currentBranch && this.props.currentBranch.pattern === 0 ? !(this.props.currentDay && this.props.currentTime) : !this.props.currentDay}>
                                                                                        {this.props.translate("book")}

                                                                                    </button>
                                                                                    <img
                                                                                        src="../images/loading-white.svg"
                                                                                        alt="loading"
                                                                                        hidden={!this.props.calculatingFees}/>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        : <div className="branch">
                                                                            <div className="branch-details">
                                                                                <p className="text-center bolder red-notation">  {this.props.translate("booking_is_not_available")}</p>
                                                                            </div>
                                                                        </div>
                                                                    : setBranchDaysSkeleton()
                                                            }
                                                        </div>

                                                        <div className="branch-fees"
                                                             hidden={!this.props.currentBookingFeesDetails}
                                                             style={this.props.styles.slideInRight}>
                                                            {
                                                                !this.props.calculatingFees && this.props.currentBookingFeesDetails ?
                                                                    <BookFeesDetails
                                                                        authUser={this.props.authUser}
                                                                        error={this.props.error}
                                                                        isPromoSuccess={this.props.isPromoSuccess}
                                                                        services={this.state.servicesToReserve}
                                                                        focusOnSidebar={(e) => this.props.focusOnSidebar(e)}
                                                                        closePageOverlay={(e) => this.props.closePageOverlay(e)}
                                                                        promoCodeLoading={this.props.promoCodeLoading}
                                                                        getBookingFees={(e, services, promoCode) => this.props.getBookingFees(e, services, promoCode)}
                                                                        rescheduleReservation={this.props.rescheduleReservation}
                                                                        submitRescheduleReservation={this.props.submitRescheduleReservation}
                                                                        submittingToServer={this.props.submittingToServer}
                                                                        translate={this.props.translate}
                                                                        currentBookingFeesDetails={this.props.currentBookingFeesDetails}
                                                                        handleSubmitReservation={(payment, promoCode, services) => this.props.handleSubmitReservation(payment, promoCode, services)}/>
                                                                    : setFeesSkeleton()
                                                            }
                                                        </div>
                                                    </div> : null
                                                }
                                            </div>
                                            :
                                            this.props.currentReservation ?
                                                this.props.history.push("/my-appointments") :
                                                <p>loading</p>

                                    }

                                    {
                                        this.props.error && this.props.error.code !== 20 && this.props.error.code !== 55 ?
                                            <div className="reservation-error-msg">
                                                <p>{this.props.error.desc}</p>
                                            </div>

                                            : null
                                    }
                                </div>
                                :
                                setBranchSkeleton()
                        }
                    </StyleRoot>
                </div>
            </div>
        )
    }
}

export default withRouter(withTranslate(SingleDoctorSidebar));